const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M8.216 9.5c-.191 0-.288.279-.154.443 1.208 1.48 2.393 3 3.648 4.419a.372.372 0 0 0 .58 0c1.255-1.419 2.44-2.94 3.648-4.419.134-.164.037-.443-.154-.443z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
